module.exports = __webpack_public_path__ + "static/media/ansiedade.00f8eee0.png";